import { useNotify } from "ra-core";

import { useInstallPrompt } from "./installPrompt";

/**
 * Install action for menu entries: opens the native dialog where the browser
 * supports it, otherwise (iOS) explains how to add the app to the home screen.
 */
export const useInstallAction = () => {
  const notify = useNotify();
  const { installMode, promptInstall } = useInstallPrompt();

  const install = () => {
    if (installMode === "prompt") {
      void promptInstall();
      return;
    }
    notify("crm.pwa.ios_instructions", { autoHideDuration: 10_000 });
  };

  return { isAvailable: installMode !== null, install };
};
